export default __webpack_public_path__ + "static/media/18.52ca25d5.jpg";